// Local
import useStyles from './styles';
import { NETWORK_CODE_MODES, SUCCESS_COPY_MESSAGES } from './constants';
import { getCustomNetworkCode, getSplitDocNetworkCode } from './helpers';

// MUI Imports
import { Box } from '@mui/system';
import { Tab } from '@mui/material';
import TabPanel from '@mui/lab/TabPanel';
import GeneralTab from '../../../../Components/GeneralTabAndTabContent';
import NetworkCode from './NetworkCode';
import ScriptSplitNetworkCode from './ScriptSplitNetworkCode/ScriptSplitNetworkCode.jsx';

const NetworkCodeContainer = ({ siteRawConfig, rawConfig, isSplitDocPresent }) => {
	const siteId = siteRawConfig?.siteId;
	const videoSectionId = rawConfig?.videoSectionId;
	const customNetworkCode = getCustomNetworkCode(siteId, videoSectionId);
	const splitDocNetworkCode = getSplitDocNetworkCode(siteId, videoSectionId);
	const customNetworkCodeSuccessMessage = SUCCESS_COPY_MESSAGES.CUSTOM_NETWORK_CODE;
	const splitDocSuccessMessage = SUCCESS_COPY_MESSAGES.SPLIT_DOC_NETWORK_CODE;
	const classes = useStyles();

	const tabListAndPanels = [
		{
			tab: (
				<Tab
					label="DEFAULT INSTREAM TAG"
					value={NETWORK_CODE_MODES.CUSTOM_NETWORK_CODE}
					key={NETWORK_CODE_MODES.CUSTOM_NETWORK_CODE}
				/>
			),
			tabPanel: (
				<TabPanel
					value={NETWORK_CODE_MODES.CUSTOM_NETWORK_CODE}
					key={NETWORK_CODE_MODES.CUSTOM_NETWORK_CODE}
					sx={{ padding: 0, marginTop: '1.5rem' }}
				>
					<NetworkCode
						networkCode={customNetworkCode}
						successMessage={customNetworkCodeSuccessMessage}
					/>
				</TabPanel>
			)
		},
		{
			tab: (
				<Tab
					label="CUSTOM TAGS"
					value={NETWORK_CODE_MODES.SPLIT_DOC_NETWORK_CODE}
					key={NETWORK_CODE_MODES.SPLIT_DOC_NETWORK_CODE}
				/>
			),
			tabPanel: (
				<TabPanel
					value={NETWORK_CODE_MODES.SPLIT_DOC_NETWORK_CODE}
					key={NETWORK_CODE_MODES.SPLIT_DOC_NETWORK_CODE}
					sx={{ padding: 0, marginTop: '1.5rem' }}
				>
					<ScriptSplitNetworkCode
						splitDocNetworkCode={splitDocNetworkCode}
						splitDocSuccessMessage={splitDocSuccessMessage}
						siteId={siteId}
					/>
				</TabPanel>
			)
		}
	];

	return (
		<Box className={classes.networkCodeContainer}>
			<GeneralTab tabListAndPanels={tabListAndPanels} tabListStyles={{ margin: '0 auto' }} />
		</Box>
	);
};

export default NetworkCodeContainer;
